import { useState, useEffect, useRef } from "react";

const SearchVideos = ({ setSearchText, existingSearchText, placeholderText, className }) => {
  const [searchTerm, setSearchTerm] = useState(existingSearchText || "");
  const prevExistingSearchText = useRef(existingSearchText);

  // Update local state when prop changes
  useEffect(() => {
    if (prevExistingSearchText.current !== existingSearchText) {
      setSearchTerm(existingSearchText || "");
      prevExistingSearchText.current = existingSearchText;
    }
  }, [existingSearchText]);

  const handleInputChange = (e) => {
    const value = e.target.value;
    setSearchTerm(value);
    if (value.trim() === "") {
      setSearchText("");
    }
  };

  const handleSearch = () => {
    setSearchText(searchTerm.trim());
  };

  return (
    <div className={`flex items-center gap-2 w-full ${className || ''}`}>
      {/* Search Input with Premium Styling */}
      <div className="relative flex-1">
        {/* Search Icon */}
        <div className="absolute inset-y-0 left-0 flex items-center pl-4 pointer-events-none">
          <svg
            className="w-5 h-5 text-slate-400"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
            />
          </svg>
        </div>

        {/* Input Field */}
        <input
          type="text"
          placeholder={placeholderText || "Search videos..."}
          value={searchTerm}
          onChange={handleInputChange}
          onKeyDown={(e) => {
            if (e.key === "Enter") {
              handleSearch();
            }
          }}
          className="w-full h-12 pl-12 pr-4 text-sm font-medium text-slate-700 placeholder-slate-400 bg-white border border-slate-200 rounded-xl shadow-sm focus:outline-none focus:ring-2 focus:ring-emerald-500 focus:border-transparent transition-all duration-200 hover:border-slate-300"
        />
      </div>

      {/* Search Button with Gradient */}
      <button
        onClick={handleSearch}
        className="h-12 px-6 text-sm font-semibold text-white bg-gradient-to-r from-[#247E45] to-[#026B33] rounded-xl shadow-lg shadow-emerald-500/20 hover:shadow-xl hover:shadow-emerald-500/30 hover:scale-105 active:scale-95 transition-all duration-200 whitespace-nowrap"
      >
        Search
      </button>
    </div>
  );
};

export default SearchVideos;
